// @flow

import TextInput from './TextInput';
export default TextInput;
export type { TextInputProps } from './TextInput';
